import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Swiper from 'swiper';
import videoService from '@services/videoService';
import LazyImage from '../../../../../basic/lazy-image';
export default {
  name: 'GiftWall',
  props: {
    giftList: Array,
    giftTabs: Array,
    isOpenGiftWall: Boolean,
    authentication: Object
  },
  data: function data() {
    return {
      VideoAPIService: null,
      isOpenGiftPopup: false,
      giftPopupTarget: null,
      giftPopupPositionX: 0,
      giftPopupPositionY: 0,
      giftPopupDialogOffset: 0,
      giftPopupDialogMargin: 6,
      selectedGiftItemHandle: 0,
      selectedGiftItemInterval: 50,
      selectedGiftItemProps: null,
      selectedGiftItemId: '',
      // finanType: 礼物类型： 101金币礼物 102 星光礼物 103 钻石礼物
      selectedGiftItemFinanType: 101,
      selectedGiftItemCount: 1,
      selectedGiftItemCountList: [1],
      level: 1,
      currentExperience: 0,
      totalExperience: 1,
      swiper: null
    };
  },
  created: function created() {
    this.VideoAPIService = videoService.createApi();
    this.updateExperience();
  },
  mounted: function mounted() {
    var _this = this;
    this.swiper = new Swiper(this.$refs.giftswiperContainer, {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          return "<a data_index=\"".concat(index, "\"  class=\"").concat(className, " gift\">").concat(_this.getTabTitle(index), "</a>");
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
    this.swiper.on('slideChange', this.updatePagination);
  },
  methods: {
    updateExperience: function updateExperience() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var profile;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this2.isAuthenticated(_this2.authentication)) {
                _context.next = 5;
                break;
              }
              _this2.level = 1;
              _this2.currentExperience = 0;
              _this2.totalExperience = 1;
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return _this2.VideoAPIService.getUserInfo(_this2.authentication.uid, _this2.authentication);
            case 7:
              profile = _context.sent;
              _this2.level = +profile.user.user_info.level;
              _this2.currentExperience = +profile.user.user_info.cur_exp;
              _this2.totalExperience = +profile.user.user_info.next_exp;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateExperienceSync: function updateExperienceSync() {
      this.updateExperience();
    },
    isAuthenticated: function isAuthenticated(authentication) {
      return !!authentication && !!authentication.uid;
    },
    updatePagination: function updatePagination() {
      try {
        var bullet = this.$refs.pagination.querySelectorAll('.swiper-pagination-bullet').item(this.swiper.activeIndex);
        var bulletX = bullet.offsetLeft;
        var bulletWidth = bullet.clientWidth;
        var viewportWidth = this.$refs.pagination.parentNode.clientWidth;
        var clientWidth = this.$refs.pagination.clientWidth;
        var scrollX = -(bulletX + bulletWidth * 0.5) + viewportWidth * 0.5;
        if (scrollX > 0) {
          scrollX = 0;
        }
        if (scrollX < viewportWidth - clientWidth) {
          scrollX = Math.min(0, viewportWidth - clientWidth);
        }
        // eslint-disable-next-line no-multi-assign
        this.$refs.pagination.style.webkitTransform = this.$refs.pagination.style.transform = "translate3d(".concat(Math.round(scrollX), "px, 0, 0)");
      } catch (c) {
        console.log(c);
      }
    },
    getTabTitle: function getTabTitle(index) {
      if (this.giftTabs && this.giftTabs[index]) {
        return this.giftTabs[index].tabTitle;
      }
      return '';
    },
    showGiftPopup: function showGiftPopup(e, props) {
      try {
        if (props && this.isGiftItemLocked(props)) {
          return;
        }
        clearTimeout(this.selectedGiftItemHandle);
        this.isOpenGiftPopup = true;
        if (!props || this.giftPopupTarget === e.currentTarget) {
          return;
        }
        this.selectedGiftItemId = props.id;
        this.selectedGiftItemProps = props;
        this.selectedGiftItemCount = 1;
        this.selectedGiftItemFinanType = props.finanType || 101;
        this.selectedGiftItemCountList = props.send_num && props.send_num.length ? props.send_num.map(function (item) {
          return +item.count;
        }).sort(function (a, b) {
          return a - b;
        }) : [1];
        this.giftPopupTarget = e.currentTarget;
        var giftwallEdge = this.$refs.giftwallContainer.getBoundingClientRect();
        var giftitemEdge = this.giftPopupTarget.getBoundingClientRect();
        var giftdialogEdge = this.$refs.giftPopupDialog.getBoundingClientRect();
        this.giftPopupPositionX = giftitemEdge.left - giftwallEdge.left + giftitemEdge.width * 0.5;
        this.giftPopupPositionY = giftitemEdge.top - giftwallEdge.top;
        this.giftPopupDialogOffset = -giftdialogEdge.width * 0.5;
        if (this.giftPopupPositionX + this.giftPopupDialogOffset < this.giftPopupDialogMargin) {
          this.giftPopupDialogOffset = this.giftPopupDialogMargin - this.giftPopupPositionX;
        }
        if (this.giftPopupPositionX + this.giftPopupDialogOffset + giftdialogEdge.width > giftwallEdge.width - this.giftPopupDialogMargin) {
          this.giftPopupDialogOffset = giftwallEdge.width - this.giftPopupDialogMargin - giftdialogEdge.width - this.giftPopupPositionX;
        }
      } catch (c) {
        console.log(c);
      }
    },
    hideGiftPopup: function hideGiftPopup() {
      var _this3 = this;
      clearTimeout(this.selectedGiftItemHandle);
      this.selectedGiftItemHandle = setTimeout(function () {
        _this3.isOpenGiftPopup = false;
        _this3.selectedGiftItemId = '';
        _this3.giftPopupTarget = null;
        _this3.selectedGiftItemFinanType = 101;
      }, this.selectedGiftItemInterval);
    },
    isGiftItemLocked: function isGiftItemLocked(gift) {
      if (+gift.lockType === 1 && this.level < +gift.levelRequired) {
        return true;
      }
      return false;
    },
    selectCurrentGiftItemCount: function selectCurrentGiftItemCount(value) {
      this.selectedGiftItemCount = value;
    },
    openGiftWallHandler: function openGiftWallHandler() {
      this.$emit('opengiftwall');
    },
    sendGiftRequest: function sendGiftRequest() {
      if (!this.selectedGiftItemId) {
        return;
      }
      this.$emit('sendgift', this.selectedGiftItemId, this.selectedGiftItemCount || 1, this.selectedGiftItemFinanType);
    }
  },
  components: {
    'lazy-image': LazyImage
  },
  watch: {
    giftTabs: function giftTabs() {
      var _this4 = this;
      this.$nextTick(function () {
        if (_this4.swiper) {
          if (_this4.swiper.pagination) {
            _this4.swiper.pagination.render();
            _this4.swiper.pagination.update();
          }
          _this4.swiper.update();
        }
      });
    },
    authentication: function authentication() {
      this.updateExperience();
    }
  }
};